<template>
  <v-form v-model="valid" ref="form" @submit.prevent="submit">
    <v-card>
      <v-card-text>
        <!-- Basic Info -->
        <div class="subheading">{{ $t("label.basicInfo") }}</div>
        <p v-html="$t('message.info.demandPlanningBasicInfo')"></p>
        <v-layout row>
          <v-flex xs3 lg2>
            <label class="form-label"
              >{{ $t("label.estimatedQuantity") }}*</label
            >
          </v-flex>
          <v-flex xs2 lg2>
            <v-text-field
              class="estimated-quantity"
              :disabled="disabled || isInternalSupplier"
              v-model="form.estimatedTime"
              :suffix="unit"
              :rules="validation.requiredNumeric"
              :maxlength="constants.LENGTH_ESTIMATED_TIME"
            ></v-text-field>
          </v-flex>
          <v-flex xs7 lg8 class="pl-2">
            <span class="form-value" v-if="form.estimatedTime">{{ cost }}</span>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs3 lg2>
            <label class="form-label">{{
              $t("label.estimatedDeliveryDate")
            }}</label>
          </v-flex>
          <v-flex xs2 lg2>
            <app-menu-date-picker
              :model.sync="form.estimatedDeliveryDate"
              :disabled="disabled"
              :label="$t('label.estimatedDeliveryDate')"
            ></app-menu-date-picker>
            <!-- <v-text-field
                            :disabled="disabled || isInternalSupplier"
                            v-model="form.estimatedDeliveryDate"
                            :mask="validation.mask.estimatedDeliveryDate"
                        ></v-text-field> -->
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs3 lg2>
            <label class="form-label">{{ $t("label.deliveryTime") }}</label>
          </v-flex>
          <v-flex xs2 lg2>
            <v-text-field
              :disabled="disabled || isInternalSupplier"
              v-model="form.daysToDelivery"
              :suffix="$t('label.days')"
              :rules="validation.biggerThanZero"
              :mask="validation.mask.daysToDelivery"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout v-show="this.demand.status.id <= 4">
          <div style="display: ruby">
            <strong>
              <v-flex>
                <label style="color: red" class="form-label">
                  {{ getFormattedDate(form.maximumApprovalDeliveryDate) }}
                </label>
              </v-flex>
            </strong>
          </div>
        </v-layout>

        <!-- Details -->
        <div class="subheading mt-3">{{ $t("label.details") }}</div>
        <p v-html="$t('message.info.demandPlanningDetails')"></p>
        <v-layout row>
          <v-flex xs3 lg2>
            <label class="form-label">{{ $t("label.description") }}*</label>
          </v-flex>
          <v-flex xs9 lg10>
            <v-text-field
              multi-line
              :disabled="disabled"
              v-model="form.description"
              :rules="validation.text"
              auto-grow
              :counter="constants.LENGTH_DESCRIPTION"
              :maxlength="constants.LENGTH_DESCRIPTION"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <!-- Files -->
        <v-layout row v-show="form.files.length > 0" class="mt-3">
          <v-flex xs9 lg10 offset-xs3 offset-lg2>
            <app-files
              :files.sync="form.files"
              :removedFiles.sync="form.removedFiles"
              :removeable="!disabled"
            ></app-files>
          </v-flex>
        </v-layout>
      </v-card-text>

      <v-card-actions v-if="!disabled">
        <v-btn
          @click="save"
          :loading="saving"
          color="primary"
          :disabled="disableApprovalButton"
          >{{ $t("label.requestApproval") }}</v-btn
        >
        <app-file-upload
          :disabled="saving"
          :model.sync="form.files"
        ></app-file-upload>
        <v-btn
          color="warning"
          :loading="rejecting"
          :disabled="saving"
          @click="reject"
          >{{ $t("label.reject") }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import constants from "@/helpers/constants";
import utilities from "@/helpers/utilities";
import validation from "@/helpers/validation";

import FileUpload from "@/components/shared/FileUpload";
import Files from "@/components/shared/Files";

import Demand from "@/helpers/entities/Demand";

import MenuDatePicker from "@/components/shared/MenuDatePicker";
import moment from "moment";

export default {
  data() {
    return {
      constants,
      validation,
      valid: true,
      saving: false,
      rejecting: false,
      form: Demand.planning.build(),
    };
  },
  computed: {
    demand() {
      return this.$store.getters.demand;
    },
    disabled() {
      return (
        !(this.demand.status.id === constants.STATUS_PLANNING) ||
        !utilities.isDemandActionable(
          this.$store.getters.profile,
          this.demand.owner,
          this.demand.status,
          constants.STATUS_PLANNING
        )
      );
    },
    disableApprovalButton() {
      const dataAtual = moment().startOf("day");
      const dataAprovacao = moment(
        this.demand.maximumApprovalDeliveryDate
      ).startOf("day");
      if (this.demand.maximumApprovalDeliveryDate) {
        if (dataAtual.isAfter(dataAprovacao) && this.demand.status.id === 3) {
          return true;
        }
      }

      return false;
    },
    cost() {
      if (!this.demand.contract.id) return null;

      const estimatedTime = utilities.toNumber(this.form.estimatedTime);
      const cost = utilities.toMoney(this.unitCost);
      const total = utilities.toMoney(this.unitCost * estimatedTime);

      return `x ${cost} = ${total}`;
    },
    unit() {
      if (!this.demand.contract.id) return null;

      const id = this.demand.contract.id;
      return this.$store.getters.contractsDictionary[
        id
      ].unit.name.toLowerCase();
    },
    exibirAprovar() {
            return !this.demand.status.id === constants.STATUS_PLANNING;
    },
    unitCost() {
      if (!this.demand.contract.id) return null;

      const id = this.demand.contract.id;
      return this.$store.getters.contractsDictionary[id].unitCost;
    },
    isInternalSupplier() {
      return !this.$store.getters.demand.system.isExternalSupplier;
    },
  },

  components: {
    appFileUpload: FileUpload,
    appFiles: Files,
    appMenuDatePicker: MenuDatePicker,
  },

  watch: {
    demand: "copyToForm",
  },

  methods: {
    async save() {
      if (!this.$refs.form.validate()) return;
      this.saving = true;
      await this.$store.dispatch(
        "planDemand",
        Demand.planning.prepare(this.form)
      );
      this.$router.push({ name: "dashboard" });
    },
    async reject() {
      this.rejecting = true;
      this.form.comments = this.form.description;
      await this.$store.dispatch(
        "rejectDemand",
        Demand.planning.prepare(this.form)
      );
      this.$router.push({ name: "dashboard" });
    },
    copyToForm(demand) {
      this.form = Demand.planning.copy(demand);
    },
    getFormattedDate(date) {
      if (date) {
        const d = moment(date).format("DD/MM/YYYY");

        return "*Este planejamento deve ser aprovado até o dia " + d;
      }
      return "*Sem data máxima de aprovação";
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/demands/steps/Planning.vue